import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { parseTime} from "@/utils/ruoyi";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.prototype.parseTime = parseTime
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
